import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import Subheader from "@components/Subheader/Subheader";
import RegisteredVessels from "@features/vessel-management/components/RegisteredVessels/RegisteredVessels";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const VesselsPage: React.FC = () => {
  const { registerVesselLabelKey } = useAuthStore();

  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId="vessels-page-subheader"
        subtitle={t("navigation.vessel-management")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t("navigation.vessel-management")}</span>
            {
              <Button
                type="button"
                variant="contained"
                color="primary"
                testId="vessel-page-create-button"
                label={
                  <span className="text-sm font-medium flex items-center gap-2">
                    <AddCircleOutlineIcon fontSize="small" />
                    {t(registerVesselLabelKey)}
                  </span>
                }
                sx={{ height: "40px", minHeight: "40px", textTransform: "none" }}
                onClick={() => navigate("/vessel-management/register/vessel-information")}
              />
            }
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6 ">
        <div className="flex flex-col gap-4">
          <RegisteredVessels />
        </div>
      </div>
    </PageLayout>
  );
};

export default VesselsPage;
